module.exports = __webpack_public_path__ + "img/图片11.63e6d787.png";